import permissions from'permissions/v1/requirements';// If you have requirements you have the hybrid (today)
export default permissions;